import moment from 'moment';

export function TooltipComponent(props) {
  return (
    <div className='bg-white px-6 py-3 font-medium shadow-md rounded-md border border-solid border-gray-300'>
      <p>{moment(props.value).fromNow()}</p>
    </div>
  );
}
